import axios, { AxiosResponse } from "axios"
import { DepartamentoReadingDtoProps } from "./DTOs/DepartamentoReadingDto"
import { DepartamentoReadingFiltersDtoProps } from "./DTOs/DepartamentoReadingFiltersDto"
import {
  DepartamentoReadingByIdAdapter,
  DepartamentoReadingFiltersAdapter,
} from "./Departamento.adapter"
import { DepartamentoReadingFiltersDtoIPagedEnumerableProps } from "./Schemas/DepartamentoReadingFiltersDtoIPagedEnumerable"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export interface GetDepartamentoByFiltersParamsProps {
  Nombre?: string
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

/**
 * Retrieves a list of Departamento entities based on the provided filters.
 * @param queryParams - Optional parameters for filtering the results.
 * @returns A Promise that resolves to a paged enumerable of DepartamentoReadingFiltersDtoIProps.
 */
export async function getDepartamentoByFilters(
  queryParams?: GetDepartamentoByFiltersParamsProps
): Promise<DepartamentoReadingFiltersDtoIPagedEnumerableProps> {
  const { data } = await axios.get("/Departamento/by-filters", {
    params: queryParams,
  })
  return {
    currentPage: data.currentPage,
    items: data.items?.map((departamento: DepartamentoReadingFiltersDtoProps) =>
      DepartamentoReadingFiltersAdapter(departamento)
    ),
    totalCount: data.totalCount,
  }
}

/**
 * Retrieves a departamento by its ID.
 * @param id - The ID of the departamento to retrieve.
 * @returns A promise that resolves to a DepartamentoReadingDtoProps object representing the departamento.
 */
export async function getDepartamentoById(
  id: string
): Promise<DepartamentoReadingDtoProps> {
  const { data } = await axios.get(`/Departamento/${id}`)
  return DepartamentoReadingByIdAdapter(data)
}

/**
 * Deletes a departamento by its ID.
 * @param id - The ID of the departamento to delete.
 * @returns A Promise that resolves to the AxiosResponse object.
 */
export async function deleteDepartamentoById(
  id: string
): Promise<AxiosResponse> {
  const response = await axios.delete(`/Departamento/${id}`)
  return response
}
